import {PlayerReduxDispatch} from "../types";

export default function cancelConfirmHint() {
  return (dispatch: PlayerReduxDispatch) => {
    dispatch({type: "cancelConfirmHint"});
  }
}
